<template>
   <section class="jsk-block">
      <div class="container">
        <!-- hello world -->
        <div class="row">
          <div class="col-12 col-lg-7 col-md-12">
            <p class="h4 pt-4">{{ $t("teachersPage.curriculaTitle[0]") }}</p>
            <p>{{ $t("teachersPage.curriculaDescr[0]") }}</p>
            <ul class="pl-3 pt-3" v-html="teachersCurriculaHelloWorld"></ul>
          </div>
          <div class="col-12 col-lg-5 col-md-12 text-right">
            <img src="./../assets/images/curricula/teachers-hw.png" class="w-75">
          </div>
        </div>

        <!-- hello js -->
        <div class="row mt-5">
          <div class="col-12 col-lg-7 col-md-12">
            <p class="h4 pt-4">{{ $t("teachersPage.curriculaTitle[1]") }}</p>
            <p>{{ $t("teachersPage.curriculaDescr[1]") }}</p>
            <ul class="pl-3 pt-3" v-html="teachersCurriculaHelloJavaScript"></ul>
          </div>
          <div class="col-12 col-lg-5 col-md-12 text-right">
            <img src="./../assets/images/curricula/teachers-hjs.png" class="w-75">
          </div>
        </div>
      </div>
    </section>
</template>


<script>
export default {
  name: "teachersCurricula",
  props: ["teachersCurriculaHelloWorld", "teachersCurriculaHelloJavaScript"]
};
</script>